import { useEffect, useState } from 'react';
import RequestAnimationFrameManager from '../utils/RequestAnimationFrameManager';
const SCROLL_DOWN = 'scrollDown';
const SCROLL_UP = 'scrollUp';
const useScrollDirection = (thresholdPixels, offsetTop = 0) => {
  const {
    0: isTop,
    1: setIsTop
  } = useState(true);
  const {
    0: isVisible,
    1: setIsVisible
  } = useState(true);
  let direction = SCROLL_DOWN;
  useEffect(() => {
    let lastScrollY = window.scrollY;
    const updateScrollDirection = () => {
      const scrollY = window.scrollY;
      const currentDirection = scrollY > lastScrollY ? SCROLL_DOWN : SCROLL_UP;
      if (direction !== currentDirection) {
        direction = currentDirection;
      }
      if (scrollY <= offsetTop) {
        setIsTop(true);
      } else if (scrollY > offsetTop) {
        setIsTop(false);
      }
      if (direction === SCROLL_DOWN && scrollY >= thresholdPixels) {
        setIsVisible(false);
      } else if (direction === SCROLL_UP) {
        setIsVisible(true);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    RequestAnimationFrameManager.addEventListener('scroll', updateScrollDirection);
    return () => {
      RequestAnimationFrameManager.removeEventListener('scroll', updateScrollDirection);
    };
  }, [thresholdPixels]);
  return {
    isTop,
    isVisible
  };
};
export default useScrollDirection;